<template>
  <v-layout justify-center align-center>
    <v-flex v-if="error" shrink>
      <div class="layout row justify-center align-center">
        <div class="mr-3 hidden-sm-and-down">
          <img :src="assets" :alt="error.message" />
        </div>
        <div class="text-md-center">
          <h1 class="red--text">{{ error.code }}</h1>
          <h2 class="my-3 headline">{{ error.message }}</h2>
          <v-btn v-if="isPublicLayout" dark :color="sistem.app_theme" to="/"
            >Halaman Utama
          </v-btn>
          <v-btn v-else color="primary" to="/dashboard">Dashboard </v-btn>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "error",
  computed: {
    ...mapState("sistem", ["sistem"]),
    error() {
      if (this.$route.meta.error) return this.$route.meta.error;
      return null;
    },
    assets() {
      if (this.$route.meta.error)
        return require(`@/assets/error/${this.$route.meta.error.code}.svg`);
      return "";
    },
    isPublicLayout() {
      return this.$store.state.ui.layout === "Public";
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 150px;
  line-height: 150px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
